import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-operations-dashboard',
  standalone: true,
  imports: [CommonModule],
  template: `<div class="p-4"><h1>Operations dashboard</h1><p class="text-600">Use the menu to open Requests.</p></div>`
})
export class OperationsDashboardComponent {}
